import { createAction } from 'typesafe-actions';
import { SetConfigAuthValuesPayload, SetRefreshOrdersIntervalPayload, GetExternalConfigPayload } from './config.types';

export const setConfigAuthValues = createAction('SET_CONFIG_AUTH_VALUES')<SetConfigAuthValuesPayload>();

export const getExternalConfigValues = createAction('GET_EXTERNAL_CONFIG_VALUES')<GetExternalConfigPayload>();

export const setRefreshOrdersInterval = createAction('SET_REFRESH_ORDERS_INTERVAL')<SetRefreshOrdersIntervalPayload>();
